module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/happypack/loader.js?id=jsx!./WithoutPermissionView.js"));
	}, "WithoutPermission");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WithoutPermission!./src/pages/WithoutPermission/WithoutPermissionView.js
// module id = ./node_modules/bundle-loader/index.js?lazy&name=WithoutPermission!./src/pages/WithoutPermission/WithoutPermissionView.js
// module chunks = 43